import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconMessageInABottle({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="nonzero">
				<path
					fill="#E42822"
					d="M7.473 11.06a.377.377 0 0 1 .486.169l.012.024 3.628 8.237a.377.377 0 0 1-.679.329l-.011-.025-3.629-8.237a.377.377 0 0 1 .193-.497M11.151 9.331a.377.377 0 0 1 .486.169l.012.024 4.326 9.78a.377.377 0 0 1-.679.33l-.011-.024-4.326-9.78a.377.377 0 0 1 .192-.499"
				/>
				<path
					fill="#E42822"
					d="M8.001 9.083c.763-.508 1.795-.332 2.261.452.391.658.212 1.522-.413 1.938a.377.377 0 0 1-.44-.611l.022-.017c.285-.19.372-.607.183-.924-.236-.396-.776-.489-1.194-.21-.541.36-.703 1.138-.351 1.73.44.74 1.323.94 2.136.512.744-.39 1.089-1.368.757-2.122a.377.377 0 1 1 .69-.304c.492 1.118-.002 2.52-1.096 3.094-1.153.607-2.48.306-3.136-.795-.555-.932-.3-2.157.581-2.743"
				/>
				<path
					fill="#FEFEFE"
					d="M8.177 4.293a.377.377 0 0 1 .486.17l.011.024.91 2.072a.377.377 0 0 1-.68.327l-.012-.024-.909-2.072a.377.377 0 0 1 .194-.497"
				/>
				<g fill="#FEFEFE">
					<path d="m6.225 5.5.012.025.917 2.082a.377.377 0 0 1-.193.498l-.011.004c-.974.68-1.42 1.611-.894 2.864l.026.059 3.692 8.383a.377.377 0 0 1-.679.329l-.012-.024-3.692-8.384c-.414-.94-.397-1.801-.025-2.552.228-.46.567-.844.971-1.16L5.546 5.83a.377.377 0 0 1 .666-.352zM9.162 6.345c.599-.144 1.225-.165 1.826.01.824.239 1.488.822 1.915 1.79a.377.377 0 1 1-.69.305c-.598-1.356-1.657-1.664-2.875-1.371a.377.377 0 1 1-.176-.734" />
					<path d="M8.64 3.513a.377.377 0 1 1 .728.196l-.014.05-.02.057a3 3 0 0 1-.133.3 3.3 3.3 0 0 1-.61.824 3.7 3.7 0 0 1-1.194.786c-.94.395-1.769.395-2.44.15a1.8 1.8 0 0 1-.383-.187.377.377 0 0 1 .404-.636l.033.02.027.016q.058.031.178.078c.498.182 1.13.182 1.89-.136.384-.162.699-.375.954-.627.205-.203.36-.42.47-.634l.032-.065.027-.057.02-.05.009-.02.013-.038z" />
					<path d="M7.17 1.842a.377.377 0 0 1 .443.26l.007.027.593 2.657a.377.377 0 0 1-.73.19l-.007-.026-.593-2.657a.377.377 0 0 1 .286-.45" />
					<path d="M7.103 1.864a.377.377 0 0 1 .321.682l-.024.011-2.464 1.056a.377.377 0 0 1-.321-.682l.024-.011z" />
				</g>
				<path
					fill="#FEFEFE"
					d="M4.563 2.963a.377.377 0 0 1 .51.057l.018.022L6.722 5.25a.377.377 0 0 1-.59.47l-.017-.021-1.63-2.207a.377.377 0 0 1 .078-.528"
				/>
				<g fill="#FEFEFE">
					<path d="M17.977 13.163a.377.377 0 0 1 .418-.332l.028.003.061.009.07.011.08.015.086.018.046.01.097.023.159.042c.457.126.915.312 1.345.57 1.07.641 1.787 1.617 1.963 2.971a.377.377 0 0 1-.748.097c-.144-1.108-.72-1.892-1.603-2.421a4.7 4.7 0 0 0-1.538-.578l-.092-.015-.04-.006a.377.377 0 0 1-.332-.417M3.94 13.455a.377.377 0 1 1 .305.69c-.766.34-1.263.817-1.545 1.4a2.97 2.97 0 0 0-.246 1.733l.01.055.01.064.007.029.003.01a.377.377 0 0 1-.73.19l-.011-.043-.011-.054-.006-.03-.012-.07-.006-.04a3.7 3.7 0 0 1 .313-2.172c.36-.745.99-1.35 1.919-1.762M19.387 19.62a.377.377 0 0 1 .443.611c-.688.5-1.562.878-2.579 1.155-.864.236-1.786.386-2.71.469q-.43.037-.806.054l-.157.006-.139.004-.146.002h-.06a.377.377 0 0 1-.021-.754h.027l.08-.001.105-.002.177-.005c.266-.01.56-.028.873-.056a15 15 0 0 0 2.579-.445c.935-.255 1.729-.598 2.334-1.038M5.165 16.994c0 .957 1.548 1.784 3.857 2.184l.197.032.2.03q.304.045.622.08l.213.022q.54.052 1.11.075l.23.007a21 21 0 0 0 1.17 0l.23-.007q.57-.023 1.11-.075l.213-.022q.318-.035.621-.08l.2-.03c2.385-.38 4.01-1.209 4.054-2.176l.001-.04h.755c0 1.978-3.424 3.193-7.77 3.193-4.3 0-7.7-1.191-7.767-3.134v-.06z" />
					<path d="m7.279 14.578.223.721-.075.024-.147.048c-1.348.455-2.089 1.073-2.114 1.72l-.001.035H4.41c0-1.11 1.041-1.967 2.79-2.523zM15.246 14.928l.124-.745.17.03.083.014.165.032.163.032.08.017.16.035q.118.026.233.054l.152.038q.189.048.369.101l.142.043q.459.14.851.31l.12.052.115.054c1.106.526 1.753 1.23 1.774 2.086l.001.045h-.755c0-.393-.264-.772-.753-1.11l-.081-.054-.086-.054a5 5 0 0 0-.43-.231l-.106-.05-.165-.071-.115-.047-.059-.023-.12-.045-.124-.044-.063-.022-.129-.042-.066-.021-.133-.041-.138-.04-.14-.039-.144-.037-.147-.036-.075-.018-.152-.035-.155-.033-.078-.016-.16-.03-.162-.03z" />
				</g>
				<path
					fill="#FEFEFE"
					d="M12.406 7.952a.377.377 0 0 1 .486.17l.011.024L17.64 18.92a.377.377 0 0 1-.68.328l-.011-.024-4.735-10.776a.377.377 0 0 1 .193-.497"
				/>
			</g>
		</svg>
	);
}
